/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {collectAndExportFiles} from '../api'

export const useMutationCollectAndExportFiles = createReactQueryMutationHook('collectAndExportFiles', collectAndExportFiles)
